/** Cookie 中存放 JWT 的键名 */
export const TOKEN_COOKIE_NAME = 'pta_token';

/** Cookie 中存放展示昵称（与 token 同步写入/清除） */
export const NICKNAME_COOKIE_NAME = 'pta_nickname';

const DEFAULT_MAX_AGE_DAYS = 7;

function escapeRegExp(s: string): string {
  return s.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&');
}

export function getTokenFromCookie(): string | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${escapeRegExp(TOKEN_COOKIE_NAME)}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function setTokenCookie(token: string, maxAgeDays = DEFAULT_MAX_AGE_DAYS): void {
  if (typeof document === 'undefined') {
    return;
  }
  const d = new Date();
  d.setTime(d.getTime() + maxAgeDays * 24 * 60 * 60 * 1000);
  document.cookie = `${TOKEN_COOKIE_NAME}=${encodeURIComponent(token)};expires=${d.toUTCString()};path=/;SameSite=Lax`;
}

export function removeTokenCookie(): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${TOKEN_COOKIE_NAME}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}

export function getNicknameFromCookie(): string | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${escapeRegExp(NICKNAME_COOKIE_NAME)}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function setNicknameCookie(nickname: string, maxAgeDays = DEFAULT_MAX_AGE_DAYS): void {
  if (typeof document === 'undefined') {
    return;
  }
  const d = new Date();
  d.setTime(d.getTime() + maxAgeDays * 24 * 60 * 60 * 1000);
  document.cookie = `${NICKNAME_COOKIE_NAME}=${encodeURIComponent(nickname)};expires=${d.toUTCString()};path=/;SameSite=Lax`;
}

export function removeNicknameCookie(): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${NICKNAME_COOKIE_NAME}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}

/** 退出登录时清除本地登录态 Cookie */
export function clearAuthCookies(): void {
  removeTokenCookie();
  removeNicknameCookie();
}
